import { render, staticRenderFns } from "./SubmissionShared.vue?vue&type=template&id=d67fd9f2&scoped=true&"
import script from "./SubmissionShared.vue?vue&type=script&lang=js&"
export * from "./SubmissionShared.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionShared.vue?vue&type=style&index=0&id=d67fd9f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67fd9f2",
  null
  
)

export default component.exports